import http from 'http/http';
import { api } from 'http/helpers';
import URLS from 'http/urls';

import {
  AvailableMenuItem,
  DishGroupWithFeedbackAvailability,
  FeedbackDishGroupReport,
  FeedbackDishGroupsReportReqParams,
  FeedbackMenuItemAnalytics,
  FeedbackMenuItemAnalyticsReqParams,
  FeedbackReport,
  FeedbackReportReqParams,
} from './types';

export const feedbackApi = {
  fetchAvailableMenuItems() {
    return http.get<AvailableMenuItem[]>(
      api(URLS.feedback.menuItemListAvailability),
    );
  },

  updateAvailableMenuItems(ids: string[]) {
    return http.put(api(URLS.feedback.menuItemListAvailability), { ids });
  },

  fetchMenuItemAvailability(id: string) {
    return http.get<boolean>(api(URLS.feedback.menuItemAvailability), {
      replacePathParams: { id },
    });
  },

  updateMenuItemAvailability(id: string, available: boolean) {
    return http.put(api(URLS.feedback.menuItemAvailability), null, {
      replacePathParams: { id },
      params: { available },
    });
  },

  fetchDishGroupAll() {
    return http.get<DishGroupWithFeedbackAvailability[]>(
      api(URLS.feedback.dishGroupAll),
    );
  },

  fetchReport(params: FeedbackReportReqParams) {
    return http.get<FeedbackReport[]>(api(URLS.feedback.range), {
      params,
    });
  },

  fetchDishGroupsReport(params: FeedbackDishGroupsReportReqParams) {
    return http.get<FeedbackDishGroupReport[]>(
      api(URLS.feedback.analyticsDishGroup),
      {
        params,
      },
    );
  },

  fetchMenuItemAnalytics(params: FeedbackMenuItemAnalyticsReqParams) {
    const { id, startDate, endDate } = params;

    return http.get<FeedbackMenuItemAnalytics>(
      api(URLS.feedback.analyticsMenuItem),
      {
        params: { startDate, endDate },
        replacePathParams: { id },
      },
    );
  },
};
